const isBase64 = (encodedString) => {
  let regexBase64 = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/
  return regexBase64.test(encodedString)
}

const isValidURL = (string) => {
  let res =
    string &&
    string.match(
      /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g,
    )
  return res !== null
}

// Email

const isValidEmail = (email) =>
  // eslint-disable-next-line no-useless-escape
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    email,
  )

const handleEmailValidation = (email) => {
  const isValid = isValidEmail(email)
  return isValid
}

// CNPJ

const isExceptionCnpj = (value) => {
  var listCNPJException = new Array(
    "00000000000000",
    "11111111111111",
    "22222222222222",
    "33333333333333",
    "44444444444444",
    "55555555555555",
    "66666666666666",
    "77777777777777",
    "88888888888888",
    "99999999999999",
  )

  return listCNPJException.includes(value)
}

const isValidCnpjNumber = (value) => {
  if (value == "" || value === undefined || value === null || value.length < 14) return false

  return true
}

const sumCnpjDigit = (value, length) => {
  var pos = length - 7
  var sumDigit = 0

  for (let i = length; i >= 1; i--) {
    sumDigit += value.charAt(length - i) * pos--
    if (pos < 2) pos = 9
  }

  return sumDigit
}

const calculateRestCnpj = (value) => {
  return value % 11 < 2 ? 0 : 11 - (value % 11)
}

const validarCNPJ = (value) => {
  value = value.replace(/\D/g, "")
  value = value.padStart(14, "0")

  if (isExceptionCnpj(value)) return false

  if (!isValidCnpjNumber(value)) return false

  if (calculateRestCnpj(sumCnpjDigit(value, 12)) != parseInt(value.substring(12, 13))) {
    return false
  }

  if (
    calculateRestCnpj(sumCnpjDigit(value.substring(0, 13), 13)) != parseInt(value.substring(13, 14))
  ) {
    return false
  }

  return true
}

// CPF

export const cpfMask = (cpf) => {
  if (!cpf) return ""
  cpf = cpf.replace(/\D/g, "").replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")
  return cpf
}

// White Space On Init

const checkWhiteSpace = (value) => {
  var stringStarted = false
  var newString = ""

  for (var i in value) {
    if (!stringStarted && value[i] == " ") {
      continue
    } else if (!stringStarted) {
      stringStarted = true
    }
    newString += value[i]
  }

  return newString
}

const checkNegativeNumber = (value) => {
  if (typeof value !== "number" || value <= 0) {
    return false
  }
  return true
}

const phoneMask = (value) => {
  if (!value) return ""
  value = value.replace(/\D/g, "")
  value = value.replace(/(\d{2})(\d)/, "($1) $2")
  value = value.replace(/(\d)(\d{4})$/, "$1-$2")
  return value
}

const numberMask = (value) => {
  if (!value) return ""
  value = value.replace(/[^0-9.,]/g, "")
  return value
}

export {
  handleEmailValidation,
  validarCNPJ,
  checkWhiteSpace,
  isValidURL,
  isBase64,
  checkNegativeNumber,
  phoneMask,
  numberMask,
}
